export const RemoveDuplicateValues = (originalArray, prop) => {
    return originalArray.filter((item, position, array) => {
        return array.map((mapItem) => {
            return mapItem[prop];
        }).indexOf(item[prop]) === position;
    });
};
